import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, Row, Tab, Table } from "react-bootstrap";
import { Election } from "../Election";
import { DistrictInfo, Voter } from "./Voter";
import { District } from "../District";
import axios, { AxiosResponse } from "axios";
import { getMessage } from "../util";
import { ObjectMap } from "../ObjectMap";

export type FoundProps = {
    messages: null | ObjectMap<string>;
    election: Election;
    voter: Voter;
    volver: () => any;
};

const Found = (props: FoundProps) => {
    const authentication =
        props.election.configuration.identification_field.split("+")[0];
    const factor: number = props.election.configuration.advanced_config.factor;

    const [districts, setDistricts] = useState<District[]>([]);
    const [district, setDistrict] = useState<String>(
        props.voter.district.district_id
    );
    const [preExtra, setPreExtra] = useState<any>(props.voter.data.pre_extra);

    const extraData = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setPreExtra(event.target.value);
    };

    const selectDistrict = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setDistrict(event.target.value);
    };

    const getVoterState = (state: string) => {
        switch (state) {
            case "ready_disabled":
                return <td>Deshabilitado</td>;
            case "ready_defaulting":
                return <td>Moroso</td>;
            case "ready":
                return <td>Habilitado</td>;
            default:
                return <td>Habilitado</td>;
        }
    };

    useEffect(() => {
        (async () => {
            try {
                const districts: AxiosResponse<District[]> = await axios({
                    method: "get",
                    url:
                        process.env.REACT_APP_API_URL +
                        "/election/" +
                        props.election._id +
                        "/districts",
                });
                setDistricts(districts.data);
            } catch (error) {}
        })();
    }, [props.election._id]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7}>
                    <p className="lead mb-1">Resultado de su consulta:</p>
                    <p className="lead fw-bold mb-4">
                        Usted está habililtad@ para votar.
                    </p>
                    <Table striped bordered hover>
                        <tbody>
                        <tr>
                            <th>Nombre:</th>
                            <td>{props.voter.data.name}</td>
                        </tr>
                        <tr>
                            <th>Población:</th>
                            {preExtra && preExtra.poblacion ? (
                                <td>{preExtra.poblacion}</td>
                            ) : (
                                <td>No hay información</td>
                            )}
                        </tr>
                        <tr>
                            <th>Región:</th>
                            {preExtra && preExtra.region ? (
                                <td>{preExtra.region}</td>
                            ) : (
                                <td>No hay información</td>
                            )}
                        </tr>
                        <tr>
                            <th>Correo:</th>
                            <td>{props.voter.data.email}</td>
                        </tr>

                        {districts.length > 1 &&
                            (props.election.configuration.advanced_config
                                .can_choose_ballotbox ? (
                                props.voter.restricted_districts_to ? (
                                    props.voter.restricted_districts_to.length > 1 ? (
                                        <tr>
                                            <th>{getMessage("district", props.messages)}</th>
                                            <td>
                                                <Form.Select onChange={selectDistrict}>
                                                    {props.voter.restricted_districts_to.map((d) => (
                                                        <option key={d.district_id} value={d.district_id}>
                                                            {d.district}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <th>{getMessage("district", props.messages)}</th>
                                            <td>{props.voter.district.district}</td>
                                        </tr>
                                    )
                                ) : (
                                    <tr>
                                        <th>{getMessage("district", props.messages)}</th>
                                        <td>
                                            <Form.Select onChange={selectDistrict}>
                                                {districts.map((d) => (
                                                    <option key={d._id} value={d._id}>
                                                        {d.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </td>
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <th>{getMessage("district", props.messages)}</th>
                                    <td>{props.voter.district.district}</td>
                                </tr>
                            ))}
                        {props.election.configuration.advanced_config.weighted && (
                            <tr>
                                <th>{getMessage("weigth", props.messages)}</th>
                                <td>{props.voter.weight / factor}</td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                    <p className="fw-bold">Información:</p>
                    <ul>
                        <li>Se muestra la primera letra de su correo y el resto con **** (por seguridad y privacidad de datos personales).</li>
                        <li>Si en el campo Correo indica <b>“Actualizar Correo Electrónico”</b> podrás solicitar una actualización del mismo en el siguiente&nbsp;
                            <a className="text-nowrap" rel="noreferrer" href="https://evoting.typeform.com/to/XiZAdoat">formulario de asistencia.</a>
                            &nbsp;para poder votar.
                        </li>
                        <li>Tu solicitud de actualización será revisada, debe cumplir con ser un correo electrónico único.</li>
                    </ul>
                </Col>
            </Row>

            {props.election.state === "open" && props.election.in_production && (
                <Row className={"justify-content-center"}>
                    <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                        <Button
                            className="EvColorBlue text-white m-1"
                            href={
                                props.election.configuration.encrypter_url.replace(
                                    "%s",
                                    props.election._id
                                ) +
                                "?district=" +
                                district
                            }
                            variant="primary"
                        >
                            {getMessage("vote_button", props.messages)}
                        </Button>
                    </Col>
                </Row>
            )}

            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                    <Button
                        className="EvColorGrisLight m-1 border-dark"
                        onClick={props.volver}
                        variant="light"
                    >
                        {getMessage("ask_again", props.messages)}
                    </Button>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Found;
